import { LOGS } from '../constants.js';
import { EVMSimulationError } from '../errors.js';
export const simulateEvmTx = async ({ tracer, simulate, data }) => {
    tracer?.traceMessage(LOGS.SIMULATING_TX);
    tracer?.traceTime('SimulatingTx');
    const simulationResult = await simulate(data)
        .catch(() => {
        tracer?.traceMessage(LOGS.SIMULATION_FAILED);
    })
        .finally(() => tracer?.traceTimeEnd('SimulatingTx'));
    if (!simulationResult ||
        simulationResult.balanceChanges.willSend.length === 0 ||
        simulationResult.balanceChanges.willReceive.length === 0) {
        tracer?.traceMessage(LOGS.SIMULATION_FAILED);
    }
    if (simulationResult?.metadata.humanReadableError) {
        throw new EVMSimulationError({
            message: simulationResult.metadata.humanReadableError,
        });
    }
    return simulationResult;
};
